import React, { useState } from 'react'
import { IReview } from '@/_types'
import { Box, Link, Text } from '@chakra-ui/react'
import { Rating, RoundedStar } from '@smastrom/react-rating'
import dayjs from 'dayjs'
import { useTranslations } from 'next-intl'

export default function ReviewCard({ data }: { data: IReview }) {
    const [showMore, setShowMore] = useState(false)
    const t = useTranslations()

    return (
        <Box key={data.id} bg="background" rounded={16} p={4}>
            <Box justifyContent={'space-between'} alignItems={'end'} lineHeight={1.2}>
                <Text fontWeight={500} fontSize={'sm'}>{data?.client_name}</Text>
                <Text color={'gray.600'} fontSize={'xs'} mt={1} mb={2}>
                    {t('published_at')} {dayjs(data.created_at).format('D MMMM, YYYY')}
                </Text>
                <Rating
                    readOnly
                    style={{ maxWidth: 90 }}
                    value={data.rating || 5}
                    itemStyles={{
                        itemShapes: RoundedStar,
                        activeFillColor: '#FFC500',
                        inactiveFillColor: '#E0E8F1',
                    }}
                />
                <Text fontSize={'xs'} mt={1} mb={2}>
                    {t.raw('rating_labels')[data.rating - 1]}
                </Text>
            </Box>
            <Box mt={4}>
                <Text fontSize={'xs'} lineHeight={1.4}>
                    {showMore
                        ? data.review_message
                        : data.review_message?.substring(0, 170) + '...'}
                </Text>
                {data.review_message?.length > 170 && (
                    <Link
                        w="full"
                        fontSize="xs"
                        width="fit-content"
                        fontWeight={400}
                        color={showMore ? "gray.600" : "primary.500"}
                        textDecor="underline"
                        transform={`translateY(${showMore ? 0 : -5}px)`}
                        onClick={() => setShowMore((prev) => !prev)}
                    >
                        {showMore ? t('constructor_zoom_out') : t('read_more_review')}
                    </Link>
                )}
            </Box>
        </Box>
    )
}
